import React, { useEffect, useState } from "react";
import { Row, Container, Col } from "react-bootstrap";
import Button from "../../stories/Button/Button";
import CollectionCard from "../../stories/CollectionCard";
import Footer from "../../stories/Footer";
import Header from "../../stories/Header";
import Input from "../../stories/Input";
import MainCard from "../../stories/MainCard";
import classes from "./MyCards.module.css";
import Carousel from "react-elastic-carousel";
import SearchIcon from "@mui/icons-material/Search";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Select from "react-select";
import { PaginationComponent } from "../../stories/Pagination/Pagination";
import { BaseURL, recordsLimit } from "../../config/apiUrl";
import { useDispatch, useSelector } from "react-redux";
import { Get } from "../../Axios/AxiosFunctions";
import NoDataComp from "../../stories/NoDataComp/NoDataComp";
import MainCardSkeleton from "../../stories/MainCard/MainCardSkeleton";
import FeaturedCardModal from "../../stories/FeaturedCardModal/FeaturedCardModal";
import OrderItem from "../../stories/OrderItem/OrderItem";
import RequestItem from "../../stories/RequestItem/RequestItem";
import { useLocation, useNavigate } from "react-router-dom";
import { getMe } from "../../handlers/helperFunctions";
import { saveLocation } from "../../redux/common/commonSlice";

const MyCards = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    dispatch(saveLocation(location));
  }, []);

  const [page, setPage] = useState(1);
  const [requestPage, setRequestPage] = useState(1);
  const [cardData, setCardData] = useState([]);
  const [cardRequestsData, setCardRequestsData] = useState([]);
  const accessToken = useSelector((state) => state?.authReducer?.access_token);

  const [cardStatus, setCardStatus] = useState(options[0]);
  const [cardRequestStatus, setCardRequestStatus] = useState(
    cardRequestoptions[0]
  );
  const [isApiCall, setIsApiCall] = useState(false);
  const [isRequestApiCall, setIsRequestApiCall] = useState(false);
  const [orderCount, setOrderCount] = useState(0);
  const [requestCount, setRequestCount] = useState(0);

  // getMyCardsData
  const getMyCardsData = async (pageNo, status) => {
    const query = {
      page: pageNo,
      limit: recordsLimit,
      status: status?.value,
    };
    const qp = new URLSearchParams(query);

    setIsApiCall(true);
    const response = await Get(BaseURL(`users/my-cards?${qp}`), accessToken);
    setIsApiCall(false);
    if (response != undefined) {
      setCardData(response?.data?.data);
      setOrderCount(response?.data?.totalRecords);
    }
  };

  // getMyRequestsData
  const getMyRequestsData = async (pageNo, status) => {
    const query = {
      page: pageNo,
      limit: recordsLimit,
      status: status?.value,
    };
    const qp = new URLSearchParams(query);

    setIsRequestApiCall(true);
    const response = await Get(BaseURL(`cards/my-requests?${qp}`), accessToken);
    setIsRequestApiCall(false);
    if (response != undefined) {
      setCardRequestsData(response?.data?.data);
      setRequestCount(response?.data?.totalRecords);
    }
  };

  useEffect(() => {
    getMyCardsData(page, cardStatus);
  }, [page, cardStatus]);

  useEffect(() => {
    getMyRequestsData(requestPage, cardRequestStatus);
  }, [requestPage, cardRequestStatus]);

  const navigate = useNavigate();
  useEffect(() => {
    getMe(dispatch, accessToken, navigate);
  }, []);

  return (
    <>
      <style>
        {`
        .css-1s2u09g-control{
            border-radius: 25px;
            padding:7px;
            background:var(--primary-color);
            color:white !important;
      
        }
        .css-1pahdxg-control{
            border-radius: 25px !important;
            padding:7px !important;
            background:var(--primary-color) !important;
            border:none;
            color:white !important;
        }
        .css-14el2xx-placeholder{
            color:white;
            font-size: 20px;
            letter-spacing: 1px;
            padding-left: 20px;
        }
 
        .css-6j8wv5-Input{
            color:white;
        }
        .css-tlfecz-indicatorContainer{
            background-image: url(../../assets/images/Polygon.png) !important;
            background-size: 100% 100%;
        }

        .css-qc6sy-singleValue{
            color:white;
            font-size: 20px;
            letter-spacing: 1px;
            padding-left: 20px;
        }
        .css-1pndypt-Input{
            color:white;
            font-size: 20px;
            letter-spacing: 1px;
            padding-left: 20px;
        }
    
        `}
      </style>
      <Header />
      <section>
        <Container className={classes.container}>
          <Row>
            <Col lg={6}></Col>
            <Col className={classes.search_main_column} lg={6}>
              <div className={classes.featured_dropDown_main}>
                <Select
                  placeholder="Order Status"
                  options={options}
                  value={cardStatus}
                  onChange={(e) => {
                    setPage(1);
                    setCardStatus(e);
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row className={classes.featured_heading}>
            <h2>My Orders</h2>
          </Row>
          <Row className={classes.CollectionCard_row}>
            {!isApiCall &&
              cardData?.map((e, i) => {
                return (
                  <Col md={6}>
                    <OrderItem data={e} />
                  </Col>
                );
              })}

            {isApiCall &&
              Array(8)
                .fill(0)
                .map((e, i) => (
                  <Col lmd={4} xl={3} key={i}>
                    <MainCardSkeleton />
                  </Col>
                ))}

            {cardData?.length === 0 && !isApiCall && (
              <NoDataComp title={"You haven't ordered any card yet."} />
            )}
          </Row>
          {orderCount > recordsLimit && (
            <Row>
              <PaginationComponent
                totalPages={Math.ceil(orderCount / recordsLimit)}
                setCurrentPage={setPage}
                currentPage={page}
              />
            </Row>
          )}
          <hr></hr>
          <Row>
            <Col lg={6}></Col>
            <Col className={classes.search_main_column} lg={6}>
              <div className={classes.featured_dropDown_main}>
                <Select
                  placeholder="Order Status"
                  options={cardRequestoptions}
                  value={cardRequestStatus}
                  onChange={(e) => {
                    setPage(1);
                    setCardRequestStatus(e);
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row className={classes.featured_heading}>
            <h2>Card Requests</h2>
          </Row>
          <Row className={classes.CollectionCard_row}>
            {!isRequestApiCall &&
              cardRequestsData?.map((e, i) => {
                return (
                  <Col md={6} key={i}>
                    <RequestItem
                      data={e}
                      setCardRequestsData={setCardRequestsData}
                    />
                  </Col>
                );
              })}

            {isRequestApiCall &&
              Array(8)
                .fill(0)
                .map((e, i) => (
                  <Col lmd={4} xl={3} key={i}>
                    <MainCardSkeleton />
                  </Col>
                ))}

            {cardRequestsData?.length === 0 && !isRequestApiCall && (
              <NoDataComp title={"You haven't ordered any card yet."} />
            )}
          </Row>
          {requestCount > recordsLimit && (
            <Row>
              <PaginationComponent
                totalPages={Math.ceil(requestCount / recordsLimit)}
                setCurrentPage={setRequestPage}
                currentPage={requestPage}
              />
            </Row>
          )}
        </Container>
      </section>
      <Footer />
    </>
  );
};

export default MyCards;

const options = [
  { value: "all", label: "All" },
  { value: "pending", label: "Pending" },
  { value: "delivered", label: "Delivered" },
];
const cardRequestoptions = [
  { value: "all", label: "All" },
  { value: "pending", label: "Pending" },
  { value: "accepted", label: "Accepted" },
  { value: "paid", label: "Paid" },
  { value: "rejected", label: "Rejected" },
];
